<template>
    <div class="login">
        <div class="logo1">
            <a href="">
                <img src="../../assets/logo.png" alt="" />
            </a>
        </div>
        <div class="logpanle">
            <div class="formbox" style="margin-top: 100px;">
                <div class="formleft" style="margin-left: -150px">
                    <div class="fltop">
                        <div class="flttile">契合科技邀请您免费试用</div>
                        <div class="flsubtitle">
                            完善信息后，立刻获得全部功能的产品试用
                        </div>
                    </div>
                    <img
                        src="../../assets/login.png"
                        alt=""
                        class="flimg"
                    />
                    <img
                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/fl2.png"
                        alt=""
                        class="flimg2"
                    />
                </div>
                <div class="form" style="margin-left: 150px">
                    <div class="right">
                        <div class="suc" v-if="!suc">
                            <div class="h3" style="margin-top: -40px;">了解更多</div>
                            <img
                                src="../../assets/code.png"
                                alt=""
                                class="succode"
                                style="margin-top: 30px;"
                            />
                            <p class="tel" style="width: 80%;font-size: 18px;line-height: 1.3;">扫描上方二维码，添加客户经理企业微信 即可咨询更多相关功能介绍</p>
                            <!-- <div class="item mobile">
                                <div class="item_txt">您的姓名</div>
                                <input
                                    type="tel"
                                    placeholder="您的姓名"
                                    class="ipt1"
                                    v-model="name"
                                    onkeyup="value=value.replace(/[\d]/g,'') "
                                    onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[\d]/g,''))"
                                    maxlength="10"
                                    name="Numbers"
                                />
                            </div>
                            <div class="item name">
                                <div class="item_txt">公司全称</div>
                                <input
                                    type="text"
                                    placeholder="请输入您的公司名称"
                                    class="ipt1"
                                    v-model="company"
                                    maxlength="20"
                                />
                            </div>
                            <div class="item mobile">
                                <div class="item_txt">手机号码</div>
                                <input
                                    type="tel"
                                    placeholder="手机号码"
                                    class="ipt1"
                                    v-model="tel"
                                    @input="input_tel"
                                    onkeyup="this.value=this.value.replace(/\D/g,'')"
                                    onafterpaste="this.value=this.value.replace(/\D/g,'')"
                                />
                            </div> -->
                            <!-- <div class="item captcha">
                                <div class="item_txt">图形验证码</div>
                                <div class="itemcap">
                                    <input
                                        type="text"
                                        maxlength="6"
                                        placeholder="图形验证码"
                                        class="ipt2"
                                        v-model="txyzm"
                                        @input="input_txyzm"
                                        onkeyup="this.value=this.value.replace(/\D/g,'')"
                                        onafterpaste="this.value=this.value.replace(/\D/g,'')"
                                    />
                                    <img src="" alt="" class="img-code" />
                                </div>
                            </div> -->
                            <!-- <div class="item code">
                                <div class="item_txt">短信验证码</div>
                                <div class="itemac">
                                    <input
                                        type="text"
                                        maxlength="6"
                                        placeholder="请输入验证码"
                                        class="ipt2"
                                        v-model="yzm"
                                        @input="input_yzm"
                                        onkeyup="this.value=this.value.replace(/\D/g,'')"
                                        onafterpaste="this.value=this.value.replace(/\D/g,'')"
                                    />
                                    <el-button type="text" class="count-down">
                                        {{ hqyzm }}
                                    </el-button>
                                </div>
                            </div>
                            <div class="tips">
                                <el-checkbox v-model="checked">
                                    我同意隐私协议 </el-checkbox
                                ><span @click="dialogVisible = true"
                                    >《隐私权政策》</span
                                >
                            </div>

                            <el-button
                                type="primary"
                                :disabled="checked ? false : true"
                                class="button1"
                                @click="tijiao"
                            >
                                立即提交
                            </el-button> -->
                        </div>
                        <div class="suc" v-if="suc">
                            <div class="h3">提交成功</div>
                            <p class="message">
                                我们将尽快与您联系并提供产品试用
                            </p>
                            <img
                                src="https://ccbhdimg.kerlala.com/hd/website/urthink/erweima1.png"
                                alt=""
                                class="succode"
                            />
                            <p class="tel">咨询电话：400-000-5560</p>
                            <el-button class="gohome1" @click="gohome"
                                >返回首页</el-button
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="契合科技使用条款及隐私条款"
            :visible.sync="dialogVisible"
            width="60%"
            center
        >
            <b> 隐私条款 </b> <br />
            在 契合科技（尔创互动） ,
            用户/客户(又称“您”)/访客的隐私是至关重要的。为了重视您对我司的信任
            ,我司将继续保护您及访客的隐私信息。本条例涵盖了我们如何收集、使用、公开、转移和存储您及访客的信息。您确认您已仔细阅读并同意本条例以下内容
            ,若有疑惑可随时与我们联系。<br />
            契合科技是北京尔创互动科技有限公司所拥有或经营的相关的网站、产品和服务。以下是关于契合科技
            如何从您/访客个人或您/访客电脑或其他设备上收集信息的说明
            ,这些信息是由
            契合科技中的“访客信息”所追踪的“访客信息”(访客即访问您所拥有或经营的网站的人)以及从您的电脑或其设备那里收集的您的“客户信息”，您通过访问www.kerlala.com并使用该服务来跟踪您的网站，从而形成“客户信息”。另外，契合科技也有使用自己的服务平台Ptengine来收集
            您以及访客 信 息 ， 这 将 有 助 于 洞 察 用
            户在www.kerlala.com上的活动。<br />
            <b>一、客户及访客个人信息的收集和使用</b><br />
            客户及访客个人信息是可以用来唯一地识别或联系一个客户及访客的数据。<br />
            1.1)关于客户及访客个人资料的收集 <br />
            当您在
            契合科技注册及使用过程中，我们可以从您那里获得以下类型的信息。<br />
            您在契合科技注册及使用过程中的以及访客的名字、电子邮件地址、电话号码、网站名称和URL、公司名称(可选)。<br />
            1.2)关于您在契合科技注册及使用过程中使用的及访客使用的浏览器或移动设备的信息的收集<br />
            您在
            契合科技注册及使用过程中使用的以及访客使用的浏览器信息、操作系统信息、移动设备的信息、IP地址、页面访问、访问时间、最后一次访问的时间、地理位置、参考网站。<br />
            您确认并同意我们可以从您及访客那里收集和使用本条例第一条所述的全部信息，且您不会因此要求我们支付任何费用。<br />
            <b>二、非客户及访客个人信息的收集和使用</b><br />
            在特殊或被允许的情况下，我们也可以进行非客户及访客个人的信息的收集、使用、转让和公开。这样我们就能更好地了解客户及访客的行为，并改进我们的产品、服务和广告。<br />
            非客户及访客个人信息，为配合本条隐私条款，聚合数据也被视为非客户及访客个人信息。<br />
            您确认并同意我们可以从您那里收集和使用本条例第二条所述的全部信息，且您不会因此要求我们支付任何费用。<br />
            <b>三、当访客进入到 契合科技 客户的网站时</b><br />
            我们的客户可以使用自定义和专有的契合科技的代码、软件或服务来获取关于访客在访问客户的web
            页面时所从事的活动的信息。<br />
            当访客访问一个使用
            契合科技服务的网站时，网站上包含的契合科技统计代码会反馈到
            契合科技的服务器，并使
            契合科技能够收集客户端的访客数据，这样可以帮助我们的客户评估和了解他们的访客是如何与他们的网站交互的，并能修改他们的网站，以使他们的访客更有价值。
            契合科技 的客户端决定客户端访客数据的类型，这些数据再被发送到 契合科技
            的服务器进行分析。这些数据可能包括或被链接到客户及访客个人可识别的信息，这取决于我们的客户如何在其网站上使用
            契合科技
            服务。此外，契合科技可能会从客户及访客的浏览器端收集计算机的某些信息。这包括浏览器信息、操作系统信息、移动设备信息、IP
            地址、访问时间和引用网站、应用程序或服务。您确认并同意我们可以从客户及访客的浏览器端收集计算机的某些信息，且我们不会因此向您及访客支付任何费用。
            由于客户有权决定从他们的访客那里收集什么信息并通过契合科技服务收集前述信息，因此，本隐私政策适用于任何客户的任何访客数据，包括
            契合科技 可能收集、获取或访问 契合科技
            服务的个人访客身份信息。因此，每个客户也应获得访客的同意，并发布一项与本条例内容相符的在线隐私政策，确保其每位访客授权客户网站在其访问时，客户网站及
            契合科技
            有权免费收集、使用及展示其有关数据和信息。若由于客户未按照前述约定与访客签订与本条例内容相符的在线隐私政策，而导致访客主张任何违约/赔偿责任及其他权利的，相应责任均由客户承担，与
            契合科技 及 北京尔创互动科技有限公司 无关。<br />
            <b>四、储存和传送您及访客的个人资料。</b> <br />
            4.1 安全。<br />
            我们将实施适当的技术和组织性措施，以保护您及访客的个人信息不受意外或非法破坏、丢失、变更或损害。我们收集的所有个人信息将存储在安全的服务器上。所有经由本网站输入的电子交易均会受到SSL
            加密技术的保护。但我们不排除因其他原因导致您及访客的个人信息受到意外或非法破坏、丢失、变更或损害等，且我们不因此向您及访客承担赔偿责任，您及访客对此表示确认及同意。<br />
            4.2
            我们将采取合理的措施，尽量确保您及访客的个人信息得到安全的处理，并符合适用的法律和本隐私政策。但我们不排除因其他原因导致您及访客的个人信息未能得到安全的处理，且我们不因此向您及访客承担赔偿责任，您及访客对此表示确认及同意。<br />
            <b>五、您及访客个人信息权利。</b> <br />
            5.1
            如果您及访客位于欧盟，根据适用的隐私法，您及访客对于我们所持有的您及访客的个人信息拥有如下权利:<br />
            (a)访问权利。 获取您及访客个人信息的权利。<br />
            (b)整改权利。
            在个人资料不准确或不完整的情况下，您及访客将获个人资料的整改权利。<br />
            (c)删除权利。
            在某些情况下，如个人资料不再需要收集或处理的情况下，您及访客将获个人资料的删除权利。<br />
            (d)限制权利。
            在某些情况下，您及访客确认并同意如个人资料的准确性受到您及访客的质疑，我们有权在您及访客个人资料上进行限制处理，使我们能够核实该个人资料的准确性。<br />
            5.2
            如果您及访客希望行使其中一项权利，请您在本隐私政策结束时使用联系方式联系我们。您也可以在我们的网站上登入您的帐户，查看并编辑您提交给我们的个人信息<br />
            5.3 您有权向您管辖范围内的监管当局提出投诉。<br />
            <b>六、Cookies 和其他技术</b> <br />
            在我们客户网站上，契合科技 使用了第一方 cookies(在用户电脑上 契合科技
            存储的小文本文件)。我们利用 cookie
            的来访信息，以便识别独立的访客，评估使用模式，执行流量分析，识别访客的偏好，诊断我们的服务器问题，分析趋势，或者管理契合科技产品和服务。
            在用户计算机上的 cookie
            不包括个人可识别的信息，如姓名、电话号码、电子邮件地址或邮寄地址，也不包括契合科技链接Cookies
            在其服务器或数据库中的个人可识别信息。互联网协议(IP)地址被认为是个人信息，并不是独立标记或公开的，而是以区域或城市的形式展示。
            另外，契合科技
            不会就您及访客的浏览器故障而负责，因为您及访客或您及访客的浏览器才是准确地实现或传达信息的原始设备，您及访客对此表示确认及同意。
            如果您选择不退出契合科技，那将会默认为您同意 cookies
            的相关设置。要了解更多关于修改 cookie
            设置的信息，请参考您的浏览器说明。<br />
            <b>七、第三方公开问题</b><br />
            契合科技
            不会向除了特殊客户以外的个体和公司售卖或分享任何访客信息，特殊客户是指
            契合科技
            在其网站上收集过访客信息的客户。这些信息以聚合报告会统计数据的形式提供给客户，统计数据识别访客对网站的聚合行为，而不是特定的或已识别的个人的行为。
            如果契合科技参与合并、收购或出售其部分或全部资产，我们将在个人信息被转移并成为另一项隐私政策之前通知。
            契合科技的所有数据都属于北京尔创互动科技有限公司。<br />
            <b>八、个人信息的保护</b> <br />
            契合科技采取充分的预防措施，以保护您及访客的个人信息免受损失、盗窃和误用，以及防止未经授权的访问、公开、变更和销毁。但我们不排除因其他原因导致您及访客的个人信息遭受损失、盗窃和误用以及未经授权的访问、公开、变更和销毁，且我们不因此向您及访客承担赔偿责任，您及访客对此表示确认及同意。
            <b>九、个人信息的完整性和保留。</b><br />
            在契合科技，我们将在一段时间内保留您及访客的个人信息，以满足本隐私政策所规定的目的，除非法律要求或允许更长期限的保留，您及访客对此表示确认及同意。<br />
            <b>十、查询</b> <br />
            如果您对契合科技的隐私政策有任何疑问或担忧，请与我们联系。<br /><br />
            本条例的最终解释权归契合科技享有。
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            checked: false,
            dialogVisible: false,
            suc: false,
            hqyzm: "获取验证码",
            tel: "",
            yzm: "",
            txyzm: "",
            djs: true,
            name: "",
            company: "",
        };
    },
    methods: {
        input_tel() {
            this.tel = this.tel.substr(0, 11);
        },
        input_yzm() {
            this.yzm = this.yzm.substr(0, 6);
        },
        input_txyzm() {
            this.txyzm = this.txyzm.substr(0, 6);
        },
        gohome() {
            this.$router.push({
                path: "/",
            });
        },
        tijiao() {
            var that = this;
            var sjh = that.tel;
            var yzm = that.yzm;
            var txyzm = that.txyzm;
            var tel_test = /^1[3456789]\d{9}$/;
            var res = tel_test.test(sjh);
            if (sjh == "") {
                this.$message({
                    message: "请输入手机号码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            if (!res) {
                this.$message({
                    message: "请输入正确的手机号码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            if (txyzm == "") {
                this.$message({
                    message: "请输入图形验证码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            if (yzm == "") {
                this.$message({
                    message: "请输入验证码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            let urlHost = process.env.API_HOST;
            let url =
                urlHost + "tp/public/index.php/directice/Wxlogin/do_login";
            let info = {
                tel: sjh,
                imgcode: txyzm,
                yzm: yzm,
            };
            this.$apiFun.saveJcInfo(url, info).then((res) => {
                if (res.code == 1) {
                    this.suc = true;
                } else {
                    this.src =
                        "https://tt.qihe-tech.com/tp/public/index.php/captcha.html?id=" +
                        Math.random();
                }
            });
        },
        huoqu() {
            var that = this;
            var sjh = that.tel;
            var txyzm = that.txyzm;
            var tel_test = /^1[3456789]\d{9}$/;
            var res = tel_test.test(sjh);
            if (sjh == "") {
                this.$message({
                    message: "请输入手机号码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            if (!res) {
                this.$message({
                    message: "请输入正确的手机号码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            if (txyzm == "") {
                this.$message({
                    message: "请输入图形验证码",
                    type: "warning",
                    showClose: true,
                });
                return false;
            }
            if (that.djs) {
                let urlHost = process.env.API_HOST;
                let url =
                    urlHost + "tp/public/index.php/directice/Wxlogin/sendyzm";
                let info = {
                    tel: sjh,
                    imgcode: txyzm,
                };
                this.$apiFun.saveJcInfo(url, info).then((res) => {
                    if (res.code == 1) {
                        that.djs = false;
                        let clock = "";
                        let nums = 90;
                        clock = setInterval(doLoop, 1000); //一秒执行一次
                        that.hqyzm = nums + "后重新获取";
                        function doLoop() {
                            nums--;
                            if (nums > 0) {
                                that.hqyzm = nums + "后重新获取";
                            } else {
                                clearInterval(clock); //清除js定时器
                                that.hqyzm = "获取验证码";
                                that.djs = true;
                                nums = 90; //重置时间
                            }
                        }
                    } else {
                        // this.src = "?id=" + Math.random();
                        if (res.code != -1) {
                            this.$toast(res.msg);
                        }
                    }
                });
            }
        },
    },
};
</script>

<style scoped>
a {
    color: #fff;
    text-decoration: none;
}
input {
    font-size: 13px;
}
input::placeholder {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747487;
}
.login {
    width: 100%;
    background: url(https://ccbhdimg.kerlala.com/hd/website/urthink/bg_jc12.png)
        no-repeat;
    background-color: #f2f3f5;
    background-size: 100% 100%;
    position: relative;
    height: 100vh;
}
.login .logo1 {
    position: absolute;
    top: 40px;
    left: 50px;
}
.login .formbox,
.login .logpanle {
    display: flex;
    align-items: center;
    justify-content: center;
}
.login .logpanle {
    height: 100%;
    flex-direction: column;
}
.login .logpanle {
    height: 100%;
    flex-direction: column;
}
.login .formbox .formleft {
    width: 780px;
    height: 618px;
    position: relative;
    top: 0;
}
.login .formbox .formleft .fltop .flttile {
    font-size: 40px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    /* color: #404c69; */
    color: #fff;
    line-height: 40px;
    padding-bottom: 20px;
    font-weight: 700;
}
.login .formbox .formleft .fltop .flsubtitle {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
    line-height: 16px;
}
.login .formbox .formleft .flimg {
    position: absolute;
    top: 100px;
    left: -250px;
    width: 1077px;
    height: 362px;
}
.login .formbox .formleft .flimg2 {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%);
    width: 544px;
    height: 84px;
}
.login .formbox .form {
    width: 450px;
    padding: 40px 30px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0 0 44px 0 rgb(4 15 37 / 16%);
    border-radius: 20px;
    display: flex;
}
.login .formbox .form .right {
    flex: 1;
}
.login .formbox .form .right .box {
    width: 370px;
    margin: 0 auto;
    flex-flow: column;
    text-align: left;
    box-sizing: border-box;
}
.login .formbox .form .right .box .item {
    margin-bottom: 28px;
    position: relative;
    justify-content: center;
    width: 100%;
}
.login .formbox .form .right .box .item .item_txt {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    padding-bottom: 8px;
    color: #747487;
}
.login .formbox .form .right .box .item input {
    padding-left: 12px;
    width: 100%;
    height: 35px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #babacc;
}
.login .formbox .form .right .box .item .itemcap {
    position: relative;
    top: 0;
}
.login .formbox .form .right .box .item .ipt2 {
    flex: 1;
}
.login .formbox .form .right .box .item .img-code {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: -15px;
    width: 90px;
    height: 38px;
    border-radius: 8px;
    overflow: hidden;
}
.login .formbox .form .right .box .item .itemac {
    display: flex;
    justify-items: center;
}
.login .formbox .form .right .box .tips {
    margin: 19px auto 0;
    font-size: 14px;
    color: #666;
    line-height: 22px;
}
.login .formbox .form .right .box .button1 {
    cursor: pointer;
    margin: 17px 0;
    font-size: 16px;
    color: #fff;
    width: 370px;
    height: 53px;
    border: 0;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
    border-radius: 4px;
}
.login .formbox .form .right .box .tips span {
    color: #5077ef;
}
.login .formbox .form .right .box .item .count-down {
    display: inline-block;
    width: 90px;
    height: 35px;
    font-size: 14px;
    text-align: right;
    cursor: pointer;
}
.login .formbox .form .right .suc {
    flex-flow: column;
    text-align: center;
}
.login .formbox .form .right .suc .h3 {
    padding-top: 53px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 28px;
}
.login .formbox .form .right .suc .message {
    margin: 16px auto 0;
    font-size: 16px;
    color: #666;
    line-height: 16px;
}
.login .formbox .form .right .suc .succode {
    width: 200px;
    height: 200px;
}
.login .formbox .form .right .suc .tel {
    margin: 18px auto 0;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #5077ef;
    line-height: 16px;
}
.login .formbox .form .right .suc .gohome1 {
    display: block;
    margin: 28px auto 0;
    width: 222px;
    height: 53px;
    background: #fff;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
    border-radius: 4px;
    opacity: 0.6;
    border: 1px solid #5077ef;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    margin-bottom: 40px;
    color: #5077ef;
}
</style>


// WEBPACK FOOTER //
// src/views/aoveras/login.vue